module.exports = __webpack_public_path__ + "static/img/login_cover.71e0fa40.png";